import { FC } from 'react';

import { AddPropButton, Container, PropsList } from './ItemAttribute-styles';
import SelectController from '@/components/form/select-controller.tsx';

interface ItemAttributeProps {
	label: string;
	values: string[];
	options: string[];
	onChange: (values: string[]) => void;
}

export const ItemAttribute: FC<ItemAttributeProps> = ({ label, values, options, onChange }) => {
	const setAttributeValue = (index: number, value: string) => {
		const attributeValues = [...values];
		attributeValues[index] = value;
		onChange(attributeValues);
	};

	const addEmptyProp = () => {
		const attributeValues = [...values, ''];
		onChange(attributeValues);
	};

	return (
		<Container>
			<label>{label}</label>
			<PropsList>
				{values.map((prop, index) => (
					<SelectController
						key={index}
						options={['', ...options.filter((item) => !values.includes(item) || item === prop)]}
						value={prop}
						onChange={({ target }) => setAttributeValue(index, target.value)}
					/>
				))}
				<AddPropButton onClick={() => addEmptyProp()}>+</AddPropButton>
			</PropsList>
		</Container>
	);
};
